import React, { useMemo, useRef } from 'react';
import { useSelector } from 'react-redux';
import SelectSetting from '../../settings_sidebar/common/SelectSetting.jsx';
import CollapsibleSection from '../../../common/CollapsibleSection.jsx';
import DatasourceTable from '../../settings_sidebar/datasource/DataSourceTable.jsx';
import SettingsSection from '../../settings_sidebar/common/SettingsSection.jsx';

function FilterSetting({ widgetId, filterIndex, selectedObject, setAttribute: initialSetAttribute, ...props }) {
  const filterContainerRef = useRef(null);
  const availableDatasources = useSelector(state => Object.values(state.datasources.datasources));
  const filters = selectedObject.filters || [];
  const filter = filters[filterIndex];

  const datasourceOptions = useMemo(() => {
    return availableDatasources.map(ds => ({
      label: ds.name,
      value: ds.id
    }));
  }, [availableDatasources]);

  const setAttribute = (path, value) => {
    const newFilters = [...filters];
    newFilters[filterIndex] = { ...filter, [path]: value };
    initialSetAttribute('filters', newFilters);
  };

  const onGridReady = (params) => {
    params.api.setGridOption('advancedFilterParent', filterContainerRef.current);
    if (filter?.advancedFilterModel) {
      params.api.setAdvancedFilterModel(filter.advancedFilterModel);
    }
  };

  const onFilterChanged = (params) => {
    const currentFilterModel = params.api.getAdvancedFilterModel();
    setAttribute('advancedFilterModel', currentFilterModel);
  };

  const gridProps = {
    enableAdvancedFilter: true,
    onFilterChanged,
    onGridReady,
  };

  return (
    <CollapsibleSection title={`Filter ${filterIndex + 1}`}>
      {!filter?.selectedDatasourceId && (
        <div className='alert alert-warning mt-1'>
          {I18n.t('select_datasource_to_filter_alert')}
        </div>
      )}
      <SettingsSection>
        <SelectSetting
          {...props}
          selectedObject={filter}
          setAttribute={setAttribute}
          options={datasourceOptions}
          attr='selectedDatasourceId'
          label={I18n.t('datasource')}
        />
        {filter?.selectedDatasourceId && (
          <>
            <DatasourceTable
              datasourceId={filter.selectedDatasourceId}
              containerHeight={300}
              gridProps={gridProps}
            />
            <div className='mt-1'>
              <label>{I18n.t('filters')}</label>
              <div ref={filterContainerRef}></div>
            </div>
          </>
        )}
      </SettingsSection>
    </CollapsibleSection>
  );
}

export default FilterSetting;
